<template>
  <v-container
    class="pa-0"
    fluid
  >
    <v-combobox
      ref="combo"
      v-model="model"
      :filter="filter"
      :hide-no-data="!search"
      :items="items"
      :search-input.sync="search"
      hide-selected
      hide-details
      :label="$t('branch')"
      :outlined="!solo"
      :solo="solo"
      :flat="solo"
      :menu-props="{maxHeight: 200}"
      multiple
      dense
      small-chips
      :background-color="(solo ? '#e5e5e5' : null)"
      @blur="$emit('blur', model)"
    >
      <template v-slot:no-data>
        <v-list-item>
          <span class="subheading">Create</span>
          <v-chip
            :color="`${colors[nonce - 1]} lighten-3`"
            label
            small
          >
            {{ search }}
          </v-chip>
        </v-list-item>
      </template>
      <template v-slot:selection="{attrs, item, parent, selected }">
        <v-chip
          v-if="item === Object(item)"
          v-bind="attrs"
          :color="item.color"
          :input-value="selected"
          label
          small
          class="px-1 mb-1 mt-1"
        >
          <span class="pr-2 white--text">
            {{ item.text }}
          </span>
          <v-icon
            small
            color="white"
            @click="parent.selectItem(item)"
          >
            mdi-close
          </v-icon>
        </v-chip>
      </template>
      <template v-slot:item="{ index, item }">
        <v-chip
          :color="item.color"
          dark
          label
          small
        >
          {{ item.text }}
        </v-chip>
        <v-spacer />
        <v-list-item-action
          class="d-inline"
          @click.stop
        >
          <v-btn
            icon
            small
            @click.stop.prevent="edit(index, item)"
          >
            <v-icon color="grey">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            small
            icon
            @click.stop.prevent="openStop(item)"
          >
            <v-icon color="pink">
              mdi-delete-outline
            </v-icon>
          </v-btn>
        </v-list-item-action>
      </template>
    </v-combobox>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="dialog"
      width="300"
    >
      <v-card
        v-if="editing"
        class="pl-4"
      >
        <v-col>
          <v-color-picker
            v-model="editingColor"
            dot-size="25"
            hide-canvas
            hide-inputs
            hide-mode-switch
            hide-sliders
            mode="hexa"
            show-swatches
            swatches-max-height="132"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <v-text-field
            v-model="editingText"
            filled
            dense
            autofocus
            flat
            @keydown="keydown($event)"
          />
        </v-col>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="submit"
          >
            {{ $t('edit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="stop"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            color="grey darken-2"
            class="close-hover"
            @click="stop = false"
          >
            <v-icon large>
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('alert-delete-tag') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="stop = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  export default {
    props: ['type', 'input', 'solo', 'height'],
    data: () => ({
      activator: null,
      attach: null,
      deleteItem: null,
      stop: false,
      formHasErrors: false,
      dialog: false,
      colors: ['green', 'red', 'blue', 'purple', 'pink', 'orange', 'deep-purple', 'teal', 'cyan', 'indigo', 'orange', 'amber', 'brown', 'deep-orange', 'grey', 'blue-grey'],
      editing: null,
      editingText: null,
      oldText: null,
      editingColor: null,
      editingIndex: -1,
      errorMessages: '',
      items: [
        { header: 'Select an option or create one' },
      ],
      nonce: 1,
      menu: false,
      model: [],
      x: 0,
      search: null,
      y: 0,
    }),
    watch: {
      model (val, prev) {
        if (val) {
          if (val.length === prev.length) {
            this.$emit('input', val)
            return
          }
          this.model = val.map(v => {
            if (typeof v === 'string') {
              v = {
                text: v,
                color: this.colors[this.nonce - 1],
                type: this.type,
                ref_id: null,
              }

              this.items.push(v)
              this.create(v)
              this.nonce++
            }
            this.$emit('input', this.model)
            return v
          })
        }
      },
      input (val, oldVal) {
        if (this.input) {
          this.model = this.input
        } else {
          this.model = []
        }
      },
    },
    mounted () {
      this.getItems()
      if (this.input) {
        this.model = this.input
      }
    },
    methods: {
      create (item) {
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'branch', {
          text: item.text,
          color: item.color,
          type: item.type,
          ref_id: item.ref_id,
        })
          .then(res => {
          })
          .catch(err => {
            var error = err.response
            if (error.status === 500) {}
            if (error.status === 401) {
              app.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.isLoading = false))
      },
      getItems () {
        var app = this
        app.isLoading = true
        app.$axios.get(this.$endpoint + 'branch/show')
          .then(res => {
            app.items = [
              ...app.items,
              ...Array.from(res.data.data),
            ]
          })
          .catch(err => {
            var error = err.response
            if (error.status === 500) {}
            if (error.status === 401) {
              app.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.isLoading = false))
      },
      keydown: function (event) {
        switch (event.keyCode) {
          case 13:
            this.submit()
            break
        }
      },
      submit () {
        var index = this.items.findIndex(x => x.text === this.oldText)
        this.items[index].text = this.editingText
        this.items[index].color = this.editingColor.hex
        this.dialog = false
        var app = this
        app.$axios.get(this.$endpoint + 'branch/' + this.editingText + '/edit', {
          params: {
            oldText: app.oldText,
            text: this.editingText,
            color: this.editingColor.hex,
          },
        })
          .then(res => {
          })
          .catch(err => {
            var error = err.response
            if (error.status === 500) {}
            if (error.status === 401) {
              app.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.isLoading = false))
      },
      edit (index, item) {
        this.editing = item
        this.editingIndex = index
        this.editingText = item.text
        this.editingColor = item.color
        this.oldText = item.text
        this.dialog = true
      },
      openStop (item) {
        this.deleteItem = item
        this.stop = true
      },
      remove () {
        var index = this.items.findIndex(x => x.text === this.deleteItem.text)
        this.items.splice(index, 1)
        this.stop = false
        var app = this
        app.$axios.delete(this.$endpoint + 'branch/' + this.deleteItem.text)
          .then(res => {
          })
          .catch(err => {
            var error = err.response
            if (error.status === 500) {}
            if (error.status === 401) {
              app.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.isLoading = false))
      },
      filter (item, queryText, itemText) {
        if (item.header) return false

        const hasValue = val => val != null ? val : ''

        const text = hasValue(itemText)
        const query = hasValue(queryText)

        return text.toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      },
    },
  }
</script>
